<template>
  <div class="section-card">
    <div class="section-header">
      <p class="section-title">{{ inquiryNo }}</p>
    </div>
    <v-divider></v-divider>
    <div class="">
      <div class="">
          <p class="card-desc">{{ description }}</p>
      
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    title?: string;
    time?: string;
    inquiryNo?: string;
    description?: string;
    icon?: string;
    iconTone?: string;
    priority?: string;
  }>(),
  {
    title: "",
    time: "",
    inquiryNo: "",
    description: "",
    icon: "mdi-wrench",
    iconTone: "card-icon--peach",
    priority: "",
  },
);

const isUrgentPriority = computed(
  () => props.priority.trim().toLowerCase() === "urgent",
);
</script>

<style scoped>

.section-card {
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.section-title {
  margin: 0;
  font-size: var(--font-size-default);
  letter-spacing: 0.1em;
  text-transform: capitalize;
  color: var(--color-title);
  font-weight: 700;
}

.card-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: grid;
  place-items: center;
}

.card-icon--peach {
  background: #fff1f2;
  color: #f97316;
}

.card-copy {
  min-width: 0;
  flex: 1;
}

.card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
}

.card-title {
  margin: 0;
  font-weight: 700;
  color: #0f172a;
  min-width: 0;
  flex: 1;
}

.card-time {
  margin: 0;
  font-size: var(--font-size-default);
  color: #94a3b8;
  white-space: nowrap;
}

.card-subtitle {
  margin: 4px 0 0;
  font-size: var(--font-size-default);
  color: var(--color-title);
}

.priority-pill {
  font-size: var(--font-size-default);
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
  text-transform: capitalize;
  margin-left: auto;
  flex-shrink: 0;
}

.priority-pill--alert {
  background: #fee2e2;
  color: #b91c1c;
}

.card-desc {
  font-size: var(--font-size-default);
  color: #475569;
  line-height: 1.4;
}
</style>
